import { Tabs, Tab } from '@celltrak/ui-components';

import AgencyInfoTab from './AgencyInfoTab';

const AgenciesCreationTab = () => (
  <Tabs activeTab="agencyInfo" fullHeight>
    <Tab title="Agency Info" tabKey="agencyInfo" fullHeight>
      <AgencyInfoTab />
    </Tab>
  </Tabs>
);
export default AgenciesCreationTab;
